import {
  jb_campaign_page_hero_css_default
} from "./chunk.3YGFBS4P.js";
import {
  ScrollTrigger
} from "./chunk.SSOBXYE4.js";
import {
  gsapWithCSS
} from "./chunk.PZPRGJID.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.SUDKOARH.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  e,
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-campaign-page-hero/jb-campaign-page-hero.ts
var JbCampaignPageHero = class extends r {
  async firstUpdated() {
    await this.updateComplete;
    this._setupAnimations();
    setTimeout(() => {
      this._scrollWrapper.style.height = "100%";
    }, 50);
  }
  _allFalsy(obj) {
    return !Object.values(obj).some((value) => !!value);
  }
  _renderBreadcrumbs() {
    return ke`
      <jb-breadcrumbs>
        ${this.breadcrumbs.backlink && ke`<jb-breadcrumbs-back-link
          .link=${this.breadcrumbs.backlink.link}
          .text=${this.breadcrumbs.backlink.text}
          slot="backlink"
        ></jb-breadcrumbs-back-link>`}
        ${this.breadcrumbs.items?.map(
      (breadcrumb) => ke`<jb-breadcrumbs-item
              .link=${breadcrumb.link}
              .text=${breadcrumb.text}
              slot="items"
            ></jb-breadcrumbs-item>`
    )}
      </jb-breadcrumbs>
    `;
  }
  _setupAnimations() {
    gsapWithCSS.registerPlugin(ScrollTrigger);
    const mm = gsapWithCSS.matchMedia();
    mm.add("(max-width: 1280px)", () => {
      gsapWithCSS.to(this._imageWrapper, {
        y: -180,
        scrollTrigger: {
          id: "scrollTriggerMoveMobile",
          trigger: this,
          scrub: true,
          start: "top +=60px",
          // 60px navbar
          end: "bottom"
        }
      });
      return () => {
      };
    });
    mm.add("(min-width: 1281px)", () => {
      const contentWrapperDiv = this._contentWrapper.querySelector("div");
      if (contentWrapperDiv.clientHeight + 185 < window.innerHeight - 100) {
        gsapWithCSS.to(this._parallaxWrapper.querySelector(".parallax-frame"), { marginTop: -80 });
      }
      gsapWithCSS.to([this._contentWrapper, this._imageWrapper.querySelector("jb-picture")], {
        y: -200,
        scrollTrigger: {
          id: "scrollTriggerMoveHero",
          trigger: this._scrollWrapper,
          scrub: true,
          start: "bottom bottom",
          end: "bottom 20%"
        }
      });
      ScrollTrigger.create({
        trigger: this._imageWrapper,
        pin: true,
        pinSpacing: false,
        start: "top-=60 top",
        // half the header size from top
        end: "bottom bottom-=60",
        // half the header size from bottom
        endTrigger: this._scrollWrapper
      });
      gsapWithCSS.to(this._imageWrapper.querySelector("jb-picture"), {
        scrollTrigger: {
          id: "scrollTriggerInset",
          trigger: this._scrollWrapper,
          scrub: true,
          start: "bottom bottom",
          end: "bottom 50%"
        },
        "--clip-path": "128px",
        yoyo: true
      });
      return () => {
      };
    });
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "campaign-page-hero"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`
      <div class="scroll-wrapper">
        <div class="breadcrumbs-outer">${this.breadcrumbs && this._renderBreadcrumbs()}</div>
        <div class="image-wrapper">
          <jb-picture
            .alt=${this.image.picture.alt}
            .imgData=${this.image.picture.imgData}
            fit="cover"
          ></jb-picture>
        </div>
        <div class="content-inset"></div>
        <div class="content-wrapper">
          <div>
            <div class="preslot">
              <div class="breadcrumbs-inner">${this.breadcrumbs && this._renderBreadcrumbs()}</div>
              <h1>${this.headline}</h1>
              <p>${this.subline}</p>
              ${this.featureList && ke` <jb-feature-list .features=${this.featureList}></jb-feature-list>`}
              ${!this._allFalsy(this.teaserMeta) ? ke` <jb-teaser-meta
                    .date=${this.teaserMeta.date}
                    .category=${this.teaserMeta.category}
                    .time=${this.teaserMeta.time}
                    .timeZone=${this.teaserMeta.timeZone ? this.teaserMeta.timeZone : D}
                    .link=${this.teaserMeta.link}
                  ></jb-teaser-meta>` : D}
              ${this.location && ke`<div class="location-wrapper">
                <jb-pin-icon></jb-pin-icon>
                <div>${this.location.map((item) => ke` <div>${item}</div> `)}</div>
              </div>`}
            </div>
            <slot @jb-link:clicked=${this._tracking}></slot>
            ${this.anchorLinks && ke`<ul class="anchor-links">
              ${this.anchorLinks.filter((item) => item.link?.href).map(
      (item) => ke`<li><jb-in-page-icon></jb-in-page-icon><a href="${item.link.href}">${item.text}</a></li>`
    )}
            </ul>`}
          </div>
        </div>
      </div>
      <div class="parallax-wrapper">
        <div class="parallax-frame">
          <slot name="parallaxElement"></slot>
        </div>
      </div>
    `;
  }
};
JbCampaignPageHero.styles = [reset_css_default, jb_campaign_page_hero_css_default];
__decorateClass([
  n({ type: Array })
], JbCampaignPageHero.prototype, "anchorLinks", 2);
__decorateClass([
  n({ type: Object })
], JbCampaignPageHero.prototype, "breadcrumbs", 2);
__decorateClass([
  n({ type: Array })
], JbCampaignPageHero.prototype, "featureList", 2);
__decorateClass([
  n()
], JbCampaignPageHero.prototype, "headline", 2);
__decorateClass([
  n({ type: Object })
], JbCampaignPageHero.prototype, "image", 2);
__decorateClass([
  n({ type: Array })
], JbCampaignPageHero.prototype, "location", 2);
__decorateClass([
  n()
], JbCampaignPageHero.prototype, "subline", 2);
__decorateClass([
  n({ type: Object })
], JbCampaignPageHero.prototype, "teaserMeta", 2);
__decorateClass([
  e(".content-inset")
], JbCampaignPageHero.prototype, "_contentInset", 2);
__decorateClass([
  e(".content-wrapper")
], JbCampaignPageHero.prototype, "_contentWrapper", 2);
__decorateClass([
  e(".image-wrapper")
], JbCampaignPageHero.prototype, "_imageWrapper", 2);
__decorateClass([
  e(".parallax-wrapper")
], JbCampaignPageHero.prototype, "_parallaxWrapper", 2);
__decorateClass([
  e(".scroll-wrapper")
], JbCampaignPageHero.prototype, "_scrollWrapper", 2);
JbCampaignPageHero = __decorateClass([
  customElement("jb-campaign-page-hero")
], JbCampaignPageHero);

export {
  JbCampaignPageHero
};
